var React = require('react');

function CheveronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 13L10 8L5 13","stroke":"#171717","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheveronUp.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheveronUp;

CheveronUp.default = CheveronUp;
